
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockItemsDialog extends _Ext.ItemEditorDialog<OpeningStockItemsRow> {
        protected getFormKey() { return OpeningStockItemsForm.formKey; }
        protected getLocalTextPrefix() { return OpeningStockItemsRow.localTextPrefix; }
        protected getDeletePermission() { return OpeningStockItemsRow.deletePermission; }
        protected getInsertPermission() { return OpeningStockItemsRow.insertPermission; }
        protected getUpdatePermission() { return OpeningStockItemsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        public form = new OpeningStockItemsForm(this.idPrefix);

        // #region Public Variables
        public Id: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number = 1;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        public LotNo: any;

        // #endregion 

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            //q.HideCategoryLable(this.element);
            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            this.form.LaborDetails.LaborListId = this.LaborListId;
            this.form.LaborDetails.LaborMarkup = this.LaborMarkup;
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // #endregion

            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                this.UpdateLabor();

                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {
                    this.UpdateLabor();
                    this.CalculateRate();
                }
            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                this.form.ProductSizeId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.ProductSizeId.updateItems();
                ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            })

            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });


            this.form.SubCategoryId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.SubCategoryId.value))
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });

            this.form.HasBom.changeSelect2(e => {
                var self = this;
                if (this.form.BOMDetails.getItems().length > 0) {
                    q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () { self.removeBOM(); }, () => { });
                }
                ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            })

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                    this.form.Purity.value = std;
                    var date = new Date((this.parentEditor.parentDialog as OpeningStockDialog).form.TransDate.value);
                    this.form.UnitRate.value = RateHelper.GetMetalRate(parseInt(this.form.MetalId.value), parseInt(this.form.KaratId.value), false, date) / this.ExchangeRate;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = std;
                    }
                    this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                var GroupSieve = OMS.AttributeMasterRow.getLookup().itemById[this.form.SieveId.value].GroupSieveId;
                this.form.GroupSieveId.value = GroupSieve;
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();

            });

            this.form.MF.changeSelect2(e => {
                this.form.MFAmount.value = this.form.GrossAmount.value / this.form.MF.value;
            });

            //this.form.StoneRate.changeSelect2(e => {
            //    this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
            //    this.CalculateRate();
            //});

            //this.form.StoneWeight.changeSelect2(e => {
            //    this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
            //    this.CalculateRate();
            //});

        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }

        getItem() {
            return this.entity;
        }

        // #region Open Dialog, Close Dialog etc

        // **** Dialog open event to set fields as per Item ****
     
        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as OpeningStockDialog);
            this.TransDate = this.ItemMaster.form.TransDate.valueAsDate

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }
            ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            q.showAndSetRequiredField(this.form.SuperTypeId);
        }

        protected validateBeforeSave() {
            var IsValid = true;
            this.form.AttributeId.value = "0";
            var t = this.RateListId;
            this.entity.RefTransId == null? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId
            this.entity.RefVoucherId == null? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount

            if (this.form.ItemTypeId.value == 101) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    BrandId: Q.parseInteger(this.form.BrandId.value),
                    CollectionId: Q.parseInteger(this.form.CollectionId.value),
                    SuperTypeId: Q.parseInteger(this.form.SuperTypeId.value),
                    ProductSizeId: Q.parseInteger(this.form.ProductSizeId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value),
                    MetalId: Q.parseInteger(this.form.MetalId.value),
                    StampId: Q.parseInteger(this.form.StampId.value)
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 104) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    MetalColorId: Q.parseInteger(this.form.MetalColorId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value)
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 105) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    ShapeId: Q.parseInteger(this.form.ShapeId.value),
                    QualityId: Q.parseInteger(this.form.QualityId.value),
                    StoneSizeId: Q.parseInteger(this.form.StoneSizeId.value),
                    SieveId: Q.parseInteger(this.form.SieveId.value),
                    GroupSieveId: this.form.GroupSieveId.value,
                    StoneColorId: Q.parseInteger(this.form.StoneColorId.value),
                    StoneCutId: Q.parseInteger(this.form.StoneCutId.value),
                    StonePolishId: Q.parseInteger(this.form.StonePolishId.value),
                    StoneSymmetryId: Q.parseInteger(this.form.StoneSymmetryId.value),
                    StoneFluorescenceId: Q.parseInteger(this.form.StoneFluorescenceId.value),
                    StoneCuletId: Q.parseInteger(this.form.StoneCuletId.value),
                    StoneGirdleId: Q.parseInteger(this.form.StoneGirdleId.value),
                    StoneTable: this.form.StoneTable.value,
                    StoneDepth: this.form.StoneDepth.value
                },
                    response => {
                        this.form.AttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 101) {

                if (this.form.HasBom.value) {
                    let items = this.form.BOMDetails.getItems();
                    let count = 0;
                    if (items.length > 0) {

                        items.forEach(function (x) {
                            if (x.ItemTypeId == 104)
                                count++
                        });

                        if (count == 0) {
                            q.Warning("Can not Save!", "Metal details not defined", false);
                            IsValid = false;
                        }
                        else
                            IsValid = true;
                    }
                    else {
                        q.Warning("Can not Save!", "Components or BOM is not defined", false);
                        IsValid = false;

                    }
                } 
                var value = q.ToBool(TabAurous.GetConfigValue(1004));
                if (value == true && Q.isEmptyOrNull(this.form.SKU.value)) {
                    var SKU = FormatHelper.GetFormats("SKU");
                    this.form.SKU.value = SKU;
                    this.entity.Studded = 1;
                }
                if (Q.isEmptyOrNull(this.form.Line_No.value)) {
                    Purchase.PurchaseMasterService.GetLineNo({}, response => this.form.Line_No.value = response.Line_No.toString(), {
                        async: false
                    });
                }


            }
            else {
                this.entity.Studded = 1;
            }
            if (this.form.ItemTypeId.value == 105) {
                if (Q.isEmptyOrNull(this.form.LotNo.value))
                    this.form.LotNo.value = FormatHelper.GetFormats("Lot");
            }

            if (this.form.Weight.value == 0) {
                q.Warning("Can not Save!", "Weight is undefined or 0", false);
                IsValid = false;
            }
            else {
                IsValid = true;
            }

            return IsValid;

        }
    }
}